/*
 * PluginSetup Messages
 *
 * This contains all the text for the PluginSetup component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.plugin.setup';

export default defineMessages({
  getStarted: {
    id: `${scope}.getStarted`,
    defaultMessage: 'Get started',
  },
  createAPlugin: {
    id: `${scope}.createAPlugin`,
    defaultMessage: 'Create a plugin',
  },
  uploadYourPlugin: {
    id: `${scope}.uploadYourPlugin`,
    defaultMessage: 'Upload your plugin',
  },
  sprCliInstallText: {
    id: `${scope}.sprCliInstallText`,
    defaultMessage: 'To create a plugin you need to install the Bronte plugin command line tools. This step requires {npmDocLink} and access to the Bronte gitlab registry. Or visit {brontePluginLink} and follow the steps in the README"',
  },
  createDirectoryText: {
    id: `${scope}.createDirectoryText`,
    defaultMessage: 'To create a basic starter plugin, navigate to the directory you wish to contain your plugin and enter this terminal command: ',
  },
  myPluginCode: {
    id: `${scope}.myPluginCode`,
    defaultMessage: 'my-plugin',
  },
  createDocumentationText: {
    id: `${scope}.createDocumentationText`,
    defaultMessage: 'This will create a new directory and plugin called “my plugin”. For documentation on how to configure and build your plugin, visit {developerDocsLink} (passkey: brontebronte)',
  },
  uploadText: {
    id: `${scope}.uploadText`,
    defaultMessage: 'First, run the upload command',
  },
  developerKeyText: {
    id: `${scope}.developerKeyText`,
    defaultMessage: 'The first time you upload, you will be prompted to enter your developer key. If you don’t have a developer key, visit the developer docs page for ',
  },
  developerKeyLinkText: {
    id: `${scope}.developerKeyLinkText`,
    defaultMessage: 'getting a developer key',
  },
  pluginIdText: {
    id: `${scope}.pluginIdText`,
    defaultMessage: 'Next, enter your plugin ID when prompted',
  },
  finishedText: {
    id: `${scope}.finishedText`,
    defaultMessage: 'Once the upload process has finished, your plugin details will appear on the plugin page.',
  },
  nextStep: {
    id: `${scope}.nextStep`,
    defaultMessage: 'Next Step',
  },
  previousStep: {
    id: `${scope}.previousStep`,
    defaultMessage: 'Previous',
  },
  done: {
    id: `${scope}.done`,
    defaultMessage: 'Done',
  },
  copied: {
    id: `${scope}.copied`,
    defaultMessage: 'Copied',
  },
  npmInstallCode: 'npm install -g @pearsontechnology/aero-plugin-cli', // the padding in this text is intended because the exact same text is going to show in the text box
  createCode: 'npx cdp-plugin create',
  uploadCode: 'npx cdp-plugin upload',
  npm: 'npm',
  brontePluginDocsLink: 'https://gitlab.com/pearsontechnology/gpt/bronte/plugin/bronte-plugin-starter',
  developerDocsLink: {
    id: `${scope}.developerDocsLink`,
    defaultMessage: 'developer docs',
  },
});
